module.exports = __webpack_public_path__ + "img/7_90.7d5b7bd8.png";